import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, UntypedFormGroup, FormControl } from '@angular/forms';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from '../../services/print.service'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { interval, Subscription, Observable } from 'rxjs';
import { ReportsService } from 'app/services/reports.service';
import { InventoryService } from 'app/services/inventory.service';
import { L } from '@angular/cdk/keycodes';

@Component({
	selector: 'app-gapp-report',
	templateUrl: './gapp-report.component.html',
	styleUrls: ['./gapp-report.component.scss']
})

export class GappReportComponent implements OnInit {
	config: any;
	user: any;
	omsService: any;

	monthFilters: UntypedFormGroup;
	stateFilters: UntypedFormGroup;
	sourceFilters: UntypedFormGroup;
	customerSearchRef = new UntypedFormControl('');
	custTypes: Object;
	itemCategories: Object;

	openBrandsTable: any = {
		PPD: true,
		Partner: true,
		Independant: true,
		Other: true
	}

	gappData: {
		'customers':any,
		'brands': any,
		'topproducts': any,
		'categories': any
	}
	customersLoading = false;


	controls: any = {
		states: [],
		monthes: [],
		sources: [],
	};

	//cust table pagination
	dataSource: MatTableDataSource<any>;
	@ViewChild('custTable') print_itemsRef: ElementRef;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	items_per_page = [25, 50, 100];
	dataObs: Observable<any>;
	customerMaster: any;

	constructor(private _changeDetectorRef: ChangeDetectorRef, private fb: UntypedFormBuilder, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private reportService: ReportsService, private customerService: CustomerService, private inventorySevice: InventoryService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
			// this.omsService.setupSocketConnection(this.user.user.userid);
		});
	}

	ngOnInit(): void {
		this.gappData = {
			'customers': false,
			'brands': false,
			'topproducts': false,
			'categories': false
		}
		this.load_data();
		this.setPagination([]);
		this.dataSource.filterPredicate = function(data, filter: string): boolean {

			return data.debtorno.includes(filter) || data.name.toLowerCase().includes(filter)
		};
	}

	load_data() {
		this.load_customers();
		this.load_brands();
		this.load_brand_categories();
		this.load_top100prods();
		this.setFilters();
	}

	load_customers() {
		this.customersLoading = true;

		this.reportService.loadGapCustomers().subscribe((res: any) => {
			this.gappData.customers = res.sort((a,b) => {return a.DELTA - b.DELTA});
			this.customerMaster = this.gappData.customers;
			this.items_per_page = [100, 250, 500, 1000];
			this.setPagination(this.gappData.customers);
			this.gappComplete();
			this.customersLoading = false;
		})
	}

	filterCustomers(event: any){
		if(event.value.length){
			this.setPagination(this.customerMaster.filter((cust) => (event.value).includes(cust.typeid)))
		}else{
			this.setPagination(this.customerMaster);
		}
		if(this.customerSearchRef.value != ''){
			this.dataSource.filter = this.customerSearchRef.value
		}
	}

	searchCustomers(event: any){
		const search = (event.target.value).trim().toLowerCase()
		this.dataSource.filter = search;
	}

	load_brands() {

		this.gappData.brands = { "0PPD": [ { "name": "L'OREAL PROFESSIONNEL", "PREV_Y": 373488.56, "THIS_Y": 134617.42, "DELTA": -238871.14, "percentChange": 0.9402414039685185 }, { "name": "MATRIX", "PREV_Y": 1391620.17, "THIS_Y": 403824.69, "DELTA": -987795.48, "percentChange": 1.1003350779594536 }, { "name": "PULPRIOT", "PREV_Y": 608280.55, "THIS_Y": 151273.85, "DELTA": -457006.7, "percentChange": 1.2033547564203435 }, { "name": "PUREOLOGY", "PREV_Y": 293723.4, "THIS_Y": 71530.32, "DELTA": -222193.08, "percentChange": 1.216650606597518 }, { "name": "REDKEN", "PREV_Y": 7864128.67, "THIS_Y": 2328313.89, "DELTA": -5535814.78, "percentChange": 1.0862587152024135 }, { "name": "BIOLAGE", "PREV_Y": 231481.85, "THIS_Y": 70291.55, "DELTA": -161190.3, "percentChange": 1.068286999450581 } ], "1Partner": [ { "name": "IGK", "PREV_Y": 225320.12, "THIS_Y": 78899.22, "DELTA": -146420.9, "percentChange": 0.9626008655465494 }, { "name": "OLAPLEX", "PREV_Y": 388455.6, "THIS_Y": 91573.5, "DELTA": -296882.1, "percentChange": 1.236933760890746 }, { "name": "SEXY HAIR COMPANY", "PREV_Y": 153174.36, "THIS_Y": 133045.09, "DELTA": -20129.27, "percentChange": 0.14065619929043952 }, { "name": "MIZANI", "PREV_Y": 23515.64, "THIS_Y": 9594.33, "DELTA": -13921.31, "percentChange": 0.8409134771188255 }, { "name": "AUTHENTIC BEAUTY CONCEPT", "PREV_Y": 125335.69, "THIS_Y": 21671.82, "DELTA": -103663.87, "percentChange": 1.410320738035764 }, { "name": "ITS A 10", "PREV_Y": 27102.97, "THIS_Y": 7545.58, "DELTA": -19557.39, "percentChange": 1.128900920817754 }, { "name": "K18", "PREV_Y": 455620.82, "THIS_Y": 167213.92, "DELTA": -288406.9, "percentChange": 0.9261105120758037 }, { "name": "MALIBU C", "PREV_Y": 62476.19, "THIS_Y": 24646.75, "DELTA": -37829.44, "percentChange": 0.8684151384239329 }, { "name": "JOICO", "PREV_Y": 100699.39, "THIS_Y": 71337.5, "DELTA": -29361.89, "percentChange": 0.34134411520691865 }, { "name": "AMIKA", "PREV_Y": 0, "THIS_Y": 92560.28, "DELTA": -92560.28, "percentChange": -2 }, { "name": "KERATIN COMPLEX", "PREV_Y": 42641.02, "THIS_Y": 10921.55, "DELTA": -31719.47, "percentChange": 1.1843893972974038 } ], "2Independant": [ { "name": "BABE", "PREV_Y": 873003.99, "THIS_Y": 231799.43, "DELTA": -641204.56, "percentChange": 1.1607577391460284 }, { "name": "COLORPROOF", "PREV_Y": 291561.26, "THIS_Y": 61541.35, "DELTA": -230019.91, "percentChange": 1.3028502394813792 }, { "name": "DIFIABA", "PREV_Y": 1185261.36, "THIS_Y": 362028.15, "DELTA": -823233.21, "percentChange": 1.064097190189055 }, { "name": "KERATHERAPY", "PREV_Y": 450757.82, "THIS_Y": 110596.59, "DELTA": -340161.23, "percentChange": 1.2119303738969467 }, { "name": "L'ANZA", "PREV_Y": 3255872.86, "THIS_Y": 1032931.04, "DELTA": -2222941.82, "percentChange": 1.0366255356184504 }, { "name": "LOMA", "PREV_Y": 646998.05, "THIS_Y": 170470.23, "DELTA": -476527.82, "percentChange": 1.1658625335285182 }, { "name": "MOROCCANOIL", "PREV_Y": 1132229.13, "THIS_Y": 314111.55, "DELTA": -818117.58, "percentChange": 1.1312930505418681 }, { "name": "GAMA PROFESSIONAL", "PREV_Y": 121084.48, "THIS_Y": 27092.36, "DELTA": -93992.12, "percentChange": 1.2686479209571482 }, { "name": "SURFACE", "PREV_Y": 153902.24, "THIS_Y": 273044.36, "DELTA": 119142.12, "percentChange": -0.5581125133681824 } ], "3Other": [ { "name": "AMERICAN CREW", "PREV_Y": 1215310.85, "THIS_Y": 216219.47, "DELTA": -999091.38, "percentChange": 1.3958368412343514 }, { "name": "AMBER", "PREV_Y": 17993.69, "THIS_Y": 4778.4, "DELTA": -13215.29, "percentChange": 1.1606567513126815 }, { "name": "ANDIS", "PREV_Y": 3855.63, "THIS_Y": 1144.78, "DELTA": -2710.85, "percentChange": 1.0842510914105046 }, { "name": "BABYLISS", "PREV_Y": 68313.46, "THIS_Y": 16283.34, "DELTA": -52030.12, "percentChange": 1.2300730051254896 }, { "name": "TAKARA BELMONT", "PREV_Y": 9346.5, "THIS_Y": 0, "DELTA": 9346.5, "percentChange": 2 }, { "name": "BETTY DAIN", "PREV_Y": 12403.41, "THIS_Y": 8718.68, "DELTA": -3684.73, "percentChange": 0.34889823876330417 }, { "name": "EDUCATION CLASSES", "PREV_Y": 57857, "THIS_Y": 31787.5, "DELTA": -26069.5, "percentChange": 0.5816196197201167 }, { "name": "FRAMAR INTERNATIONAL", "PREV_Y": 184916.13, "THIS_Y": 51992.09, "DELTA": -132924.04, "percentChange": 1.1221564198996556 }, { "name": "FROMM INTERNATIONAL", "PREV_Y": 3022.81, "THIS_Y": 416.14, "DELTA": -2606.67, "percentChange": 1.515968536908068 }, { "name": "HAIR ART INT'L, INC", "PREV_Y": 1712.17, "THIS_Y": 369.35, "DELTA": -1342.82, "percentChange": 1.2902302163803376 }, { "name": "HOT TOOLS", "PREV_Y": 17808.7, "THIS_Y": 3655.14, "DELTA": -14153.56, "percentChange": 1.3188283177660662 }, { "name": "J&D BEAUTY PRODUCTS", "PREV_Y": 33908.62, "THIS_Y": 14388.54, "DELTA": -19520.08, "percentChange": 0.8083324154049638 }, { "name": "FEATHER", "PREV_Y": 16309.29, "THIS_Y": 4300.5, "DELTA": -12008.79, "percentChange": 1.1653481185397814 }, { "name": "JOEWELL", "PREV_Y": 17717.04, "THIS_Y": 3326.45, "DELTA": -14390.59, "percentChange": 1.367699939506232 }, { "name": "KAEMARK SALON FURNISHING", "PREV_Y": 2040, "THIS_Y": 0, "DELTA": 2040, "percentChange": 2 }, { "name": "KASHO", "PREV_Y": 721.78, "THIS_Y": 44.53, "DELTA": -677.25, "percentChange": 1.7675614307525676 }, { "name": "KAYLINE ENTERPRISES, INC", "PREV_Y": 442.78, "THIS_Y": 391.75, "DELTA": -51.03, "percentChange": 0.12229638239488089 }, { "name": "KING RESEARCH, INC.", "PREV_Y": 45189.84, "THIS_Y": 13379.37, "DELTA": -31810.47, "percentChange": 1.0862523158499149 }, { "name": "VENDOR: MISC", "PREV_Y": 146119.82, "THIS_Y": -28403.45, "DELTA": -174523.27, "percentChange": 2.9651486874765167 }, { "name": "OSTER PRODUCTS", "PREV_Y": 12553.33, "THIS_Y": 2007.2, "DELTA": -10546.13, "percentChange": 1.4485915004467556 }, { "name": "PARTEX INTERNATIONAL", "PREV_Y": 7065.11, "THIS_Y": 1681.04, "DELTA": -5384.07, "percentChange": 1.2311862933976663 }, { "name": "PRAVANA", "PREV_Y": 559082.89, "THIS_Y": 142013.83, "DELTA": -417069.06, "percentChange": 1.1897618348578212 }, { "name": "PRODUCT CLUB", "PREV_Y": 6601.63, "THIS_Y": 2228.57, "DELTA": -4373.06, "percentChange": 0.9904781318656427 }, { "name": "SPILO WORLDWIDE", "PREV_Y": 158.34, "THIS_Y": 0, "DELTA": 158.34, "percentChange": 2 }, { "name": "STYLE EDIT", "PREV_Y": 85314.8, "THIS_Y": 23243.1, "DELTA": -62071.7, "percentChange": 1.1435685472913535 }, { "name": "TRESSA", "PREV_Y": 36043.33, "THIS_Y": 10329.94, "DELTA": -25713.39, "percentChange": 1.1089746312908275 }, { "name": "SPORNETTE", "PREV_Y": 17027.4, "THIS_Y": 1328.55, "DELTA": -15698.85, "percentChange": 1.7104916934291063 }, { "name": "QUALITY TOUCH", "PREV_Y": 11295.25, "THIS_Y": 3152.55, "DELTA": -8142.7, "percentChange": 1.1271889145752294 }, { "name": "PRODUCT CLUB", "PREV_Y": 85516.68, "THIS_Y": 26073.05, "DELTA": -59443.63, "percentChange": 1.065396071842812 }, { "name": "TRUEPLEX", "PREV_Y": 8583.73, "THIS_Y": 1649.03, "DELTA": -6934.7, "percentChange": 1.3553918981780086 }, { "name": "GRAHAM PROFESSIONAL ", "PREV_Y": 18819.33, "THIS_Y": 4511.1, "DELTA": -14308.23, "percentChange": 1.2265723349291033 }, { "name": "DIANE ", "PREV_Y": 6483.18, "THIS_Y": 1805.34, "DELTA": -4677.84, "percentChange": 1.1287515744668528 }, { "name": "SALON TECH", "PREV_Y": 59.99, "THIS_Y": 0, "DELTA": 59.99, "percentChange": 2 }, { "name": "COLOR TRAK", "PREV_Y": 140395.66, "THIS_Y": 36927.18, "DELTA": -103468.48, "percentChange": 1.1670067995752833 }, { "name": "KERACOLOR", "PREV_Y": 21544.65, "THIS_Y": 5366.4, "DELTA": -16178.25, "percentChange": 1.2023499640482256 }, { "name": "GRANDE COSMETICS ", "PREV_Y": 117820.19, "THIS_Y": 21027.06, "DELTA": -96793.13, "percentChange": 1.3942390648716485 }, { "name": "WAHL", "PREV_Y": 8123.9, "THIS_Y": 1527.55, "DELTA": -6596.35, "percentChange": 1.366913779794746 }, { "name": "PROLIFIC", "PREV_Y": 82018.9, "THIS_Y": 17208.05, "DELTA": -64810.85, "percentChange": 1.3063154717543972 }, { "name": "OLIVA GARDEN", "PREV_Y": 18352.21, "THIS_Y": 5276, "DELTA": -13076.21, "percentChange": 1.1068303523627054 }, { "name": "CRICKET", "PREV_Y": 13103.02, "THIS_Y": 3802.9, "DELTA": -9300.12, "percentChange": 1.1002205144706707 }, { "name": "CLUBMAN", "PREV_Y": 769.34, "THIS_Y": 293.1, "DELTA": -476.24, "percentChange": 0.8965023907232408 }, { "name": "PERSONNA", "PREV_Y": 113.01, "THIS_Y": 0, "DELTA": 113.01, "percentChange": 2 }, { "name": "DENMAN", "PREV_Y": 2075.81, "THIS_Y": 309, "DELTA": -1766.81, "percentChange": 1.4817197177133608 }, { "name": "REYNOLDS", "PREV_Y": 37234.71, "THIS_Y": 9700.86, "DELTA": -27533.85, "percentChange": 1.1732615583447692 }, { "name": "KENRA", "PREV_Y": 517161.81, "THIS_Y": 136176.3, "DELTA": -380985.51, "percentChange": 1.1662736465809411 }, { "name": "SOLANO", "PREV_Y": 8427.7, "THIS_Y": 1982.25, "DELTA": -6445.45, "percentChange": 1.2383248718773865 }, { "name": "LOMA ESSENTIALS", "PREV_Y": 14872.68, "THIS_Y": 3101.29, "DELTA": -11771.39, "percentChange": 1.309826376699193 }, { "name": "BIO ELEMENTS", "PREV_Y": 2257.35, "THIS_Y": 0, "DELTA": 2257.35, "percentChange": 2 }, { "name": "12 BENEFITS", "PREV_Y": 11390.98, "THIS_Y": 2314.17, "DELTA": -9076.81, "percentChange": 1.3245838243288106 } ] };
		this.gappComplete();
		this.reportService.loadGapBrands().subscribe((res) => {
			// this.gappData.brands = res;
			this.gappComplete();
		})

		this.reportService.buildGapBrands().subscribe((res) => {

		})
	}

	load_brand_categories(){
		const mfgid = 23; //runs off mfgid
		this.reportService.loadGapBrandCategories(mfgid).subscribe((res) => {
			this.gappData.categories = res;
			this.gappComplete();
		})
	}

	load_top100prods() {
		const mfgid = 23; //runs off mfgid
		this.reportService.loadGapBrandTopProds(mfgid).subscribe((res) => {
			this.gappData.topproducts = res;
			this.gappComplete();
		})
	}

	gappComplete() {
		let done = true;
		Object.values(this.gappData).map((i) => {
			if(i == false){
				done = false;
			}
		});
		if(done){
			const x ={
				brands :this.gappData.brands,
				topproducts: this.gappData.topproducts,
				categories: this.gappData.categories
			}
			//console.log(JSON.stringify(x).replace(/[\\']/g, '\\$&').replace(/\u0000/g, '\\0'));
		}
	}


	setFilters(){
		//month name filters
		this.monthFilters = new UntypedFormGroup({});
		for(let m = 1; m < 13; m++){
			const name = Intl.DateTimeFormat('en', { month: 'long' }).format(new Date(2000,m-1,1));
			this.controls['monthes'].push(name);
			this.monthFilters.addControl(name + '_fc', new FormControl(false))
		}

		//state filters
		const states = [
			{ name:'Alabama', abbrev: 'AL' },
			{ name:'Alaska', abbrev: 'AK' },
			{ name:'Arizona', abbrev: 'AZ' },
			{ name:'Arkansas', abbrev: 'AR' },
			{ name:'California', abbrev: 'CA' },
			{ name:'Colorado', abbrev: 'CO' },
			{ name:'Connecticut', abbrev: 'CT' },
			{ name:'Delaware', abbrev: 'DE' },
			{ name:'Washington, D.C.', abbrev: 'DC' },
			{ name:'Florida', abbrev: 'FL' },
			{ name:'Georgia', abbrev: 'GA' },
			{ name:'Hawaii', abbrev: 'HI' },
			{ name:'Idaho', abbrev: 'ID' },
			{ name:'Illinois', abbrev: 'IL' },
			{ name:'Indiana', abbrev: 'IN' },
			{ name:'Iowa', abbrev: 'IA' },
			{ name:'Kansas', abbrev: 'KS' },
			{ name:'Kentucky', abbrev: 'KY' },
			{ name:'Louisiana', abbrev: 'LA' },
			{ name:'Maine', abbrev: 'ME' },
			{ name:'Maryland', abbrev: 'MD' },
			{ name:'Massachusetts', abbrev: 'MA' },
			{ name:'Michigan', abbrev: 'MI' },
			{ name:'Minnesota', abbrev: 'MN' },
			{ name:'Mississippi', abbrev: 'MS' },
			{ name:'Missouri', abbrev: 'MO' },
			{ name:'Montana', abbrev: 'MT' },
			{ name:'Nebraska', abbrev: 'NE' },
			{ name:'Nevada', abbrev: 'NV' },
			{ name:'New Hampshire', abbrev:'NH' },
			{ name:'New Jersey', abbrev:'NJ' },
			{ name:'New Mexico', abbrev: 'NM' },
			{ name:'New York', abbrev:'NY' },
			{ name:'North Carolina', abbrev:'NC' },
			{ name:'North Dakota', abbrev:'ND' },
			{ name:'Ohio', abbrev: 'OH' },
			{ name:'Oklahoma', abbrev: 'OK' },
			{ name:'Oregon', abbrev: 'OR' },
			{ name:'Pennsylvania', abbrev: 'PA' },
			{ name:'Rhode Island',abbrev: 'RI' },
			{ name:'South Carolina', abbrev: 'SC' },
			{ name:'South Dakota', abbrev: 'SD' },
			{ name:'Tennessee',abbrev: 'TN' },
			{ name:'Texas', abbrev: 'TX' },
			{ name:'Utah', abbrev: 'UT' },
			{ name:'Vermont', abbrev: 'VT' },
			{ name:'Virginia', abbrev: 'VA' },
			{ name:'Washington', abbrev: 'WA' },
			{ name:'West Virginia', abbrev: 'WV' },
			{ name:'Wisconsin', abbrev: 'WI' },
			{ name:'Wyoming', abbrev: 'WY' },
		];


		this.stateFilters = new UntypedFormGroup({});
		(states).forEach(state => {
			this.controls['states'].push(state.name)
			this.stateFilters.addControl(state.name+'_fc', new FormControl(false))
		});


		//source filters
		const sources = [
			{ id:1,name:'Back Office' },
			{ id:2,name:'POS' },
			{ id:3,name:'Sales Person' },
			{ id:4,name:'Web' }
		];
		this.sourceFilters = new UntypedFormGroup({});
		(sources).forEach(source => {
			this.controls['sources'].push(source.name);
			this.sourceFilters.addControl(source.name + '_fc', new FormControl(false))
		});

		//customer types
		this.customerService.getCustomerTypes().subscribe((res) => {
			this.custTypes = res;
		});

		//item categories
		this.inventorySevice.getItemCategories().subscribe((res) => {
			this.itemCategories = res;
		})
	}

	collapseTable(table: any){
		this.openBrandsTable[table] = this.openBrandsTable[table] == true ? false : true;
		if(this.openBrandsTable[table]){
			document.getElementById(table).style.transition = '200ms';
			document.getElementById(table).style.height = 'auto';
		}else{
			document.getElementById(table).style.transition = '200ms';
			document.getElementById(table).style.height = '0px';
		}
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource<any>(tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}


}
